import axios from "axios";
import React, { useEffect, useState } from "react";
import { Title } from "../common/Title";
import theme from "../../theme";
import { CommonInput } from "../common/CommonInput";
import { BiSearchAlt2 } from "react-icons/bi";
import { Wrapper, ModifyForm, ModifyBtn } from "./layout";
import { AddrModal } from "./AddrModal";
import { useSelector, useDispatch } from "react-redux";
import { setAddress } from "../../modules/form";
import { useNavigate } from "react-router-dom";
import CommonContainer from "../common/CommonContainer";

// joso.co.kr API
const API_KEY = "devU01TX0FVVEgyMDIyMDEyODIzMjIyNjExMjE5NjE=";

function Address() {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [addressInfo, setAddressInfo] = useState([]);
  const [data, setData] = useState({});
  // data 유효성 검사
  const dataLength = Object.keys(data).length;
  const [disabled, setDisabled] = useState(true);
  // redux 상태 관리
  const { workType } = useSelector((state) => ({
    workType: state.form.workType,
  }));
  const dispatch = useDispatch();
  const handleSetAddress = (key, value) => dispatch(setAddress(key, value));
  //  리다이렉트
  useEffect(() => {
    if (!workType) navigate("/");
  }, [navigate, workType]);
  // 버튼 활성화
  useEffect(() => {
    if (dataLength === 9) {
      setDisabled(false);
    }
  }, [data, dataLength]);
  // 주소 API 불러오기
  const getAddress = async (keyword) => {
    await axios
      .get(
        `https://www.juso.go.kr/addrlink/addrLinkApi.do?
			currentPage=1&countPerPage=10&keyword=${keyword}&confmKey=${API_KEY}&resultType=json`
      )
      .then((response) => {
        const results = response.data.results.juso;
        setAddressInfo(() => results);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  // 모달 오픈
  const searchAddressModal = () => {
    setOpenModal((prev) => !prev);
  };
  // dataHandler
  const dataHandler = (e) => {
    const {
      lnbrMnnm,
      buldMnnm,
      roadAddr,
      jibunAddr,
      siNm,
      sggNm,
      emdNm,
      liNm,
    } = e;
    setData({
      locationCode: lnbrMnnm,
      roadCode: buldMnnm,
      roadAddress: roadAddr,
      jibunAddress: jibunAddr,
      sidoName: siNm,
      sigunguName: sggNm,
      myundongName: emdNm,
      liName: liNm,
    });
    searchAddressModal();
  };
  // AddaddressDetail
  const AddaddressDetail = (e) => {
    setData({ ...data, addressDetail: e });
  };
  // HandleAddress - add redux state
  const HandleAddress = () => {
    for (let key in data) {
      handleSetAddress(key, data[key]);
    }
    navigate("/phone-number");
  };

  return (
    <Wrapper modal={openModal}>
      {!openModal ? (
        <CommonContainer
          disabled={disabled}
          handleNextClick={HandleAddress}
          button={true}
        >
          <Title
            title="돌봄 주소"
            description="돌봄 주소를 입력해주세요"
            progressNum="3"
            button={() => navigate(-1)}
          />
          {dataLength !== 0 ? (
            <ModifyForm>
              <CommonInput
                type={"text"}
                readonly
                styleWidth={"250px"}
                searchImage={BiSearchAlt2}
                inputValue={data.roadAddress || data.jibunAddress}
                style={{
                  marginTop: 20,
                  marginBottom: 20,
                  marginRight: 5,
                }}
              />
              <ModifyBtn onClick={searchAddressModal} theme={theme}>
                재검색
              </ModifyBtn>
            </ModifyForm>
          ) : (
            <CommonInput
              styleWidth={"328px"}
              placeHolder="주소 또는 건물명으로 검색"
              addressModal={searchAddressModal}
              searchImage={BiSearchAlt2}
              style={{
                marginTop: 20,
                marginBottom: 10,
              }}
            />
          )}

          <CommonInput
            styleWidth={"328px"}
            placeHolder="상세 주소를 입력해주세요"
            setInputValue={(e) => AddaddressDetail(e)}
          />
        </CommonContainer>
      ) : (
        <AddrModal
          address={addressInfo}
          searchAddressModal={searchAddressModal}
          getAddress={getAddress}
          dataHandler={dataHandler}
        />
      )}
    </Wrapper>
  );
}

export default Address;
